// extracted by mini-css-extract-plugin
export default {"chartContainer":"Chart_chartContainer__tWEJk","title":"Chart_title__IGOlm","chartWrapper":"Chart_chartWrapper__LqrX6"};